"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyRow = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Cell = require("../Cell");
var _Row = require("../Row");
require("./StickyRow.scss");
const StickyRow = _ref => {
  let {
    row,
    className,
    cellClassName,
    isVisible,
    top = 0
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, 'cds-ComparisonTableStickyRow', {
      'cds-ComparisonTableStickyRow--Visible': isVisible
    }),
    style: {
      top
    }
  }, /*#__PURE__*/_react.default.createElement(_Row.Row, null, row.map(cell => /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    id: cell.id,
    key: (0, _key.createKey)('sticky-row', cell.id),
    className: (0, _classnames.default)(cellClassName, 'cds-ComparisonTableStickyRow-Cell')
  }, cell.content))));
};
exports.StickyRow = StickyRow;
//# sourceMappingURL=StickyRow.js.map